import postMessageService from '@/modules/common/services/postMessageService'

const AnalyticsPlugin = {
    install(Vue, options) {
        Vue.prototype.$track = (eventName, options = {}) => {
            postMessageService.post('analyticsEvent', {eventName, options})
        };
    }
};

window.addEventListener("message", (event) => {
  // IMPORTANT: Mirrors behavior from pov/src/plugins/analytics.js
  // If VueJS is hosting a micro-service iframe - get analytics events
  // Consider any modifications made here to be included in the POV equivalent
  let event_data = event.data
  if (event_data.event === 'analyticsServiceEvent'){
    if (event_data.origin) event_data.data.options['source'] = event_data.origin
    postMessageService.post('analyticsEvent', {eventName: event_data.data.eventName, options: event_data.data.options})
  }


  // …
}, false);

export default AnalyticsPlugin;
